import * as React from 'react';
import { Trans } from '@lingui/macro';

export const FinancialQuestionnaireTitle = (): JSX.Element => (
  <Trans>
    Questionnaire concernant votre situation financière
  </Trans>
);
